import { createAction } from '@reduxjs/toolkit';

export const DELETE_CONVERSATION_ACTION_TYPE = 'saga/deleteConversation';
export const deleteConversationAction = createAction(DELETE_CONVERSATION_ACTION_TYPE);
